import type { ReactNode } from 'react';
import { Badge, DataTable } from '@/components/data';

export type SyncStatus = 'ok' | 'warn' | 'err';

/** Status de uma execução de sync (`badge` com bolinha). */
export function SyncStatusBadge({ status, children }: { status: SyncStatus; children: ReactNode }) {
  return <Badge tone={status} dot>{children}</Badge>;
}

export type SyncRun = {
  /** Início (ex.: "23/10 07:02"). */
  at: string;
  /** Origem: Cron, Webhook, Manual. */
  src: string;
  st: SyncStatus;
  label: string;
  created: number;
  updated: number;
  removed: number;
  /** Duração ou erro. */
  info: string;
};

/** Execuções recentes da sincronização com a Pluggy. */
export function SyncRunsTable({ runs }: { runs: readonly SyncRun[] }) {
  return (
    <DataTable
      rows={runs}
      rowKey={(r) => r.at}
      columns={[
        { key: 'at', header: 'Início', render: (r) => r.at },
        { key: 'src', header: 'Origem', render: (r) => r.src },
        { key: 'st', header: 'Status', render: (r) => <SyncStatusBadge status={r.st}>{r.label}</SyncStatusBadge> },
        { key: 'created', header: 'Novas', align: 'right', render: (r) => r.created.toLocaleString('pt-BR') },
        { key: 'updated', header: 'Atualizadas', align: 'right', render: (r) => r.updated },
        { key: 'removed', header: 'Removidas', align: 'right', render: (r) => r.removed },
        { key: 'info', header: 'Duração / erro', render: (r) => r.info },
      ]}
    />
  );
}
